export const filterFalsy = <T>(array: (T | undefined | null | false)[]) => {
  return array?.filter((e): e is T => !!e) ?? [];
};

export default filterFalsy;
